<template>
  <el-card :body-style="{ 'padding': '5px' }">
    <div slot="header">
      <b>
        Repasses do Dia
      </b>
      <el-tooltip v-if="tooltipQuantidadeRepassesIsVisible" :content="quantidadeRepasses">
        <i class="el-icon-info" style="color: #399" />
      </el-tooltip>
    </div>

    <div>
      <el-table
        :data="repasses"
        height="300"
        stripe
        border
        size="mini"
        highlight-current-row
        :empty-text="isLoading ? 'Carregando...' : 'Nenhum Repasse para o dia de hoje'"
      >
        <el-table-column
          prop="aluguel.idNaImobiliaria"
          label="Aluguel"
          width="80"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="mesSerie"
          label="Mês"
          width="60"
          sortable
        />

        <el-table-column
          prop="cliente.nome"
          label="Cliente"
          show-overflow-tooltip
          sortable
        />

        <el-table-column
          prop="valor"
          label="Valor"
          width="100"
          :formatter="formatarValor"
          show-overflow-tooltip
          sortable
        />
      </el-table>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios';
import URLS from '../../util/urls';
import util from '../../util/funcoes';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      repasses: [],
      isLoading: false,
    };
  },

  computed: {
    tooltipQuantidadeRepassesIsVisible() {
      return this.repasses.length > 0;
    },
    quantidadeRepasses() {
      const quantidade = this.repasses.length;
      switch(quantidade) {
        case 1:
          return 'Exibindo 1 Repasse';
        default:
          return `Exibindo ${quantidade} Repasses`;
      }
    },
  },

  created() {
    this.listar();
  },

  methods: {
    ...mapActions('loginStore', [
      'relogar',
    ]),

    listar() {
      this.limparRepasses();
      this.showLoading();
      this.recuperarRepassesDoDia()
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    recuperarRepassesDoDia() {
      return axios.get(URLS.DASHBOARD_RECUPERAR_REPASSES_DO_DIA)
        .then(this.handleResultadoRecuperarRepassesDoDia)
        .catch(error => {
          throw error;
        });
    },

    handleResultadoRecuperarRepassesDoDia(response) {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return this.relogar().then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return this.recuperarRepassesDoDia();
            }
          }).catch(error => {
            throw error;
          });

        case 'SUCESSO':
          this.repasses = [...response.data.lista];
          break;

        case 'ERRO':
          this.repasses = [];
      }
    },

    limparRepasses() {
      this.repasses = [];
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarValor(repasse) {
      return util.formatarValor(repasse.valor);
    },
  },
};
</script>